module.exports = new __parcel__URL__("32359_h.051fc716.jpg").toString();